import React, { HTMLAttributes } from "react";
import classNames from "classnames";

import { OrderedListWrapper, OrderedListItem } from "./OrderedList.styled";

export type OrderedListProps = {};

const OrderedListComp = React.forwardRef<HTMLOListElement, HTMLAttributes<HTMLOListElement>>((props, ref) => {
  const { className, ...restProps } = props;
  const oderedListClass = classNames("c-ordered-list", className);

  return <OrderedListWrapper data-testid="qa-ordered-list" ref={ref} className={oderedListClass} {...restProps} />;
});

const OrderedList = Object.assign(OrderedListComp, { Item: OrderedListItem });

export default OrderedList;
